import React from 'react';
import '../styles/Hero.css';

interface HeroProps {
  onOpenBooking: () => void;
}

const Hero: React.FC<HeroProps> = ({ onOpenBooking }) => {
  const handleBookConsultation = () => {
    onOpenBooking();
  };

  const handleLearnMore = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content animate-slideInLeft">
          <h1 className="hero-title">
            Complete Legal Solution <span className="highlight">at Your Doorstep</span>
          </h1>
          <p className="hero-description">
            Making legal support more accessible, transparent, and client-focused. 
            Get expert legal consultation from anywhere in NCR.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary animate-pulse" onClick={handleBookConsultation}>
              Book Consultation
            </button>
            <button className="btn btn-secondary" onClick={handleLearnMore}>
              Learn More
            </button>
          </div>
          <div className="hero-stats animate-fadeInUp">
            <div className="stat">
              <span className="stat-number">1000+</span>
              <span className="stat-label">Happy Clients</span>
            </div>
            <div className="stat">
              <span className="stat-number">4</span>
              <span className="stat-label">Cities Covered</span>
            </div>
            <div className="stat" style={{ display: 'none' }}>
              <span className="stat-number">₹2000</span>
              <span className="stat-label">Flat Rate</span>
            </div>
          </div>
        </div>
        <div className="hero-image animate-slideInRight">
          <div className="hero-card animate-float">
            <i className="fas fa-balance-scale"></i>
            <h3>Expert Legal Advice</h3>
            <p>Professional consultation at transparent pricing</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;